export default "__VITE_ASSET__64a3e36c__"